import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=27b3c605&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=ts"
export * from "./breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=27b3c605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3c605",
  null
  
)

export default component.exports